import toast from "react-hot-toast";
import { isEmpty } from "@/utils/utils";

/**
 * 显示成功提示
 * @param title
 * @param duration
 */
function showSuccess(title: any, duration?: number) {
  if (isEmpty(title)) {
    return;
  }
  toast.success(title, {
    duration: duration,
  });
}

/**
 * 显示失败提示
 * @param errData
 * @param duration
 */
function showError(errData: any, duration?: number) {
  if (isEmpty(errData)) {
    return;
  }
  if (typeof errData !== "string") {
    if (typeof errData.msg !== "string") {
      errData = "系统异常，请重试";
    } else {
      errData = errData.msg;
    }
  }
  toast.error(errData, {
    duration: duration,
  });
}

/**
 * 显示无图标提示
 * @param title
 * @param duration
 */
function showToast(title: any, duration?: number) {
  if (isEmpty(title)) {
    return;
  }
  toast(title, {
    duration: duration,
  });
}

export const ToastUtil = {
  showSuccess,
  showToast,
  showError,
};
